import React, { useEffect, useState } from 'react'
import axios from 'axios'
import '../../../styles/Evenements.css'

function Evenements() {
  const [itemsevenement, setItemsEvenement] = useState([])

  useEffect(() => {
    axios
      .get('./json/evenements.json', {
        headers: {
          'Cache-Control': 'no-cache',
        },
      })
      .then(function (response) {
        setItemsEvenement(response.data)
      })
      .catch(function (error) {
        console.error('Erreur lors de la mise à jour des données JSON', error)
      })
  }, [])

  return (
    <div id="Evenements" className="evenements">
      <div id="section-Evenements" className="sectionEvenements">
        <div id="texte-Evenements" className="containerTexteEvenements">
          <div id="text-Evenements-1" className="blockText">
            <p
              dangerouslySetInnerHTML={{
                __html: itemsevenement.textEvenement1,
              }}
            />
          </div>
          <div id="textEvenements2" className="blockText">
            <blockquote>
              <p
                dangerouslySetInnerHTML={{
                  __html: itemsevenement.textEvenement2,
                }}
              />
            </blockquote>
          </div>
        </div>
        <div id="image" className="containerImageEvenements">
          <figure id="img_bloc" className="blocImageEvenements">
            <img
              src={itemsevenement.imagesrc}
              data-src={itemsevenement.imagedatasrc}
              alt={itemsevenement.imagealt}
              width={itemsevenement.imagewidth}
              height={itemsevenement.imageheight}
              // className={itemsevenement.imageclass}
            />
          </figure>
        </div>
      </div>
    </div>
  )
}

export default Evenements
